import { render } from "./PlayTimeReport.vue?vue&type=template&id=18e82594"
import script from "./PlayTimeReport.vue?vue&type=script&lang=js"
export * from "./PlayTimeReport.vue?vue&type=script&lang=js"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__